// https://github.com/facebook/react/issues/15446
// ssr的原因导致图片的onError事件不会触发，所以需要手动判断图片是否有效

export function isImageValid(src) {
  if (!src) return Promise.resolve(false);
  var promise = new Promise(function (resolve) {
    var img = document.createElement('img');
    img.onerror = function () {
      return resolve(false);
    };
    img.onload = function () {
      return resolve(true);
    };
    img.srcset = src;
  });
  return promise;
}